import { Api, Config } from './api'

export const ApiObterFuncionarios = async (filtros) => {
   const params = new URLSearchParams()

   if (filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros.limite) {
      params.append('limite', filtros.limite)
   }
   if (filtros.matricula) {
      params.append('matricula', filtros.matricula)
   }

   if (filtros.ordenar) {
      params.append('ordenar', filtros.ordenar)
   }

   const { data } = await Api.get(`/funcionarios`, Config(params))

   return data
}

export const ApiObterFuncionariosFiltro = async (filtro) => {
   const { data } = await Api.get(`/funcionarios/filtro/${filtro}`, Config())

   return data
}

export const ApiObterFuncionariosPorMatricula = async (matricula) => {
   const { data } = await Api.get(`/funcionarios/${matricula}`, Config())

   return data
}
